import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

// Priority enum specific to amenities options endpoint
const AmenityOptionsPriorityEnum = z.enum([
  'CRITICAL',
  'NICE_TO_HAVE',
  'IMPORTANT',
  'NOT_RELAVANT',
]);

const AmenityOptionsConfigDtoSchema = z.object({
  facilityTypeId: z.number(),
  points: z.number(),
  priority: AmenityOptionsPriorityEnum,
});

const AmenityOptionsAmenityDtoSchema = z.object({
  id: z.number(),
  name: z.string(),
  isSelected: z.boolean(),
  configs: z.array(AmenityOptionsConfigDtoSchema).nullable(),
});

const AmenityCategoryResponseDtoSchema = z.object({
  category: z.object({
    id: z.number(),
    name: z.string(),
  }),
  amenities: z.array(AmenityOptionsAmenityDtoSchema),
});

const GetAllAmenitiesResponseDtoSchema = z.array(
  AmenityCategoryResponseDtoSchema
);

export type AmenityOptionsConfigDto = z.infer<
  typeof AmenityOptionsConfigDtoSchema
>;
export type AmenityOptionsAmenityDto = z.infer<
  typeof AmenityOptionsAmenityDtoSchema
>;
export type AmenityCategoryResponseDto = z.infer<
  typeof AmenityCategoryResponseDtoSchema
>;
export type GetAllAmenitiesResponseDto = z.infer<
  typeof GetAllAmenitiesResponseDtoSchema
>;

export const getAllAmenities = (config?: AxiosRequestConfig) => {
  return api
    .get('/amenities', config)
    .then(responseContract(GetAllAmenitiesResponseDtoSchema));
};
